import { Core } from "@faire/design-tokens";
import { IBrandViewV2Response } from "@faire/web-api/indigofair/data/IBrandViewV2Response";
import { optimizeImageUrl } from "@faire/web/common/transform-images";
import { Column, Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

import { EAEAEA_PIXEL } from "@faire/retailer/consts/EAEAEA_PIXEL";
import type { IReviewSummary } from "@faire/retailer/lib/buildReviewSummary";

import { Rating } from "../Rating";
import { StoryModalButton } from "../StoryModalButton";

import * as styles from "./styles.css";

type Props = {
  brand: IBrandViewV2Response.ILeanBrand;
  reviewSummary: IReviewSummary | undefined;
  location: string | undefined;
  brandAboutSubheader: string | null;
};

export const Story: React.FC<Props> = ({
  brand,
  reviewSummary,
  location,
  brandAboutSubheader,
}) => {
  return (
    <div className={styles.container}>
      <Row>
        <img
          src={
            brand.profile_image
              ? optimizeImageUrl(brand.profile_image, true, {
                  width: styles.PROFILE_IMAGE_SIZE,
                  height: styles.PROFILE_IMAGE_SIZE,
                  resizeMethod: "fill",
                  serverOnly: true,
                })
              : EAEAEA_PIXEL
          }
          className={styles.profileImage}
          width={styles.PROFILE_IMAGE_SIZE}
          height={styles.PROFILE_IMAGE_SIZE}
        />
        <Spacer width="2x" />
        <Column>
          <Typography>{brand.name}</Typography>
          {location ? (
            <Typography color={Core.text.subdued}>{location}</Typography>
          ) : null}
          {reviewSummary ? (
            <>
              <Spacer height={2} />
              <Rating reviewSummary={reviewSummary} />
            </>
          ) : null}
        </Column>
      </Row>
      <Spacer height="2x" />

      {brand.description ? (
        <>
          <Typography align="center" color={Core.text.subdued} maxLines={3}>
            {brand.description}
          </Typography>
          <Spacer height="2x" />
        </>
      ) : null}

      <StoryModalButton
        brand={brand}
        brandAboutSubheader={brandAboutSubheader}
      />
    </div>
  );
};
